import React from "react";
import Navbar from "../components/Navbar";
import HeroVenue from "../components/Hero_venue";
import Footer from "../components//Footer";
import HeaderImage from "../assets/hero_wij-01.jpg";
import ImpactImage from "../gallery/whatIsJudo.jpg";
import judo_1 from "../assets/judo_1.jpg";
import judo_2 from "../assets/judo_2.jpg";
import Canonical from "../components/canonical";

export function Judo() {
  const heroAreaName = "What is Judo";

  return (
    <React.Fragment>
      <Canonical />
      <Navbar />
      <HeroVenue heroAreaName={heroAreaName} imageSrc={HeaderImage} />
      <div className="w-full bg-[#01184D] text-white content-center mx-auto">
        {/* Item 1 */}
        <div className=" max-w-[800px] w-full mx-auto text-center flex flex-col justify-center">
          <div className="flex flex-wrap items-start justify-center gap-x-4 pb-4 ">
            <h1 className="w-full uppercase my-8 md:text-4xl text-xl sm:text-2xl font-bold">
              What is Judo?
            </h1>
            <div className="items-center mx-auto">
              <img
                src={ImpactImage}
                alt="The White belt is about to hit the mat at speed. His time till impact? Less than a second"
                className="md:w-[500px] w-[300px]"
              ></img>
            </div>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              Judo is both a sport and a fighting art form for self defense.
            </p>
            <h2 className="mt-4 md:text-3xl text-lg sm:text-xl font-bold">
              Control. Self control. Focus. Commitment.
            </h2>
            <p className="md:text-xl sm:text-lg text-sm my-4 font-bold">
              The White belt is about to hit the mat at speed. His time till
              impact? Less than a second.
            </p>
          </div>
        </div>
        <div className="bg-[#075AAA] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] flex flex-wrap items-start justify-center gap-x-4 pb-4 ">
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              Judo teaches the benefits above, together with manners and
              etiquette. But also self confidence, self-respect, and respect for
              others. Fitness, strength and stamina are essential to develop.
              Judo is generally translated as “gentle” from the character “Ju”.
              But it is never gentle, and neither is karate or taekwondo. Ju is
              often better translated as supple and requires mobility and
              movement.
              <br />
              <br />
              These moves were developed in Japan for over 300 years and began
              to be more structured in 1532. By 1870 there were over 300 jujitsu
              schools in Japan. In 1882, judo evolved from many of these
              techniques, which allowed them to be used more safely in general
              practice. In 1882, Jigoro Kano set up the first club, The Kodokan.
              <br />
              <br />
              Judo is generally translated as “gentle” from the character “Ju”.
              However, it is never gentle, but neither is karate or taekwondo.
              Ju is often better translated as supple and requires mobility and
              movement. Judo breeds fitness, strength, self-confidence, manners,
              self-respect, and respect for others.
              <br />
              <br />
              <span className="font-bold">
                Parents should note that judo is a hands-on full contact martial
                art which involves child to child and adult to child contact.
              </span>
            </p>
          </div>
        </div>
        <div className="bg-[#C8102E] w-full mx-auto text-center flex flex-col items-center justify-center">
          <div className="max-w-[800px] flex flex-wrap items-start justify-center ">
            <p className="md:text-xl sm:text-lg text-sm my-4 font-bold mx-6">
              We teach judo <u>as a sport</u> to embed these qualities in
              players.
            </p>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-4">
              Beyond being an Olympic sport, judo is one of the most effective
              self-defence systems in the world.
              <br />
              <br />
              Developed from traditional jujitsu and formally established in
              1882, judo was created for real combat situations. Where Brazilian
              Jiu-Jitsu (BJJ) focuses on fighting once you’re on the ground,
              judo’s strength lies in its{" "}
              <b>
                <u>takedowns</u>
              </b>
              —powerful techniques designed to throw and control an attacker
              quickly, decisively, and often before they can cause harm.
              <br />
              <br />
              <b>
                Judo offers over 100 throws and takedown techniques, giving you
                the tools to deal with attackers of all shapes and sizes.
                <br />
                <br />
                These can be applied from grappling, as an opponent closes in,
                with a single hand—or even without using your hands at all.
              </b>
              <br />
              <br />
              Once an attacker is on the ground, judo gives you the skills to{" "}
              <b>
                dominate and control —{" "}
                <u>
                  through immobilisations, restraints, and, at advanced levels,
                  submissions such as arm locks and strangles (the latter
                  reserved for adults and advanced juniors).
                </u>
              </b>
              <br />
              <br />
              In a street situation, judo gives you the ability to: Take control
              fast, ending the fight on your terms. Neutralise an attacker
              without relying on punches or kicks. Stay safe by using efficient
              techniques that work under pressure.
              <br />
              <br />
              Far from being “gentle,” judo is a powerful and practical martial
              art—a proven system for self-defence that sharpens both body and
              mind while preparing you to handle real-world confrontations.
              <br />
              <br />
            </p>
            <div className="items-center mx-auto my-6">
              <img
                src={judo_1}
                alt="A man is about to be thrown onto a mat"
                className="md:w-[500px] w-[300px]"
              ></img>
            </div>
            <div className="items-center mx-auto mt-3">
              <img
                src={judo_2}
                alt="A man is about to be flipped onto a mat"
                className="md:w-[500px] w-[300px]"
              ></img>
            </div>
            <p className="mx-6 md:text-xl sm:text-lg text-sm my-8">
              <b>
                We will also teach judo to fighters{" "}
                <u>as a system of fighting and self defence.</u>
              </b>
            </p>
          </div>
        </div>
      </div>
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
